import { Stack } from '@mui/material';
// modales
import WalletTransfer from './WalletTransfer';

const BodyRechargeWallet = ({ institutions, dni }) => {
  return (
    <>
      <Stack gap={'64px'} marginX={'auto'} marginBottom={'60px'}>
        <WalletTransfer />
      </Stack>
    </>
  );
};

export default BodyRechargeWallet;
